"use client";

export { AuthView } from "@daveyplate/better-auth-ui";
